import { gql, useLazyQuery } from "@apollo/client";
import {
  QueryNewWebServicePreview,
  QueryNewWebServicePreviewVariables
} from "./schema/QueryNewWebServicePreview";
import {
  QueryUpgradeWebservicePreview,
  QueryUpgradeWebservicePreviewVariables
} from "./schema/QueryUpgradeWebservicePreview";

export const queryNewWebServicePreview = gql`
  query QueryNewWebServicePreview(
    $solutionKey: Key!
    $calculationRuleAddress: String!
  ) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        useCases {
          calculationRule(calculationRuleAddress: $calculationRuleAddress) {
            dataDependencies {
              name
              icon
            }
            schema {
              input {
                name
                columns {
                  nullable
                  name
                  typeName
                }
              }
              output {
                name
                columns {
                  name
                  nullable
                  typeName
                }
              }
            }
          }
          useCases(latestVersionOnly: true) {
            detail {
              key
              version
            }
          }
        }
      }
    }
  }
`;

export const queryUpgradeWebservicePreview = gql`
  query QueryUpgradeWebservicePreview(
    $solutionKey: Key!
    $useCaseKey: Key!
    $calculationRuleAddress: String!
  ) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        useCases {
          useCase(useCaseKey: $useCaseKey) {
            detail {
              description
              image
              key
              name
              tags
              version
              transactionTable
              __typename
              nextVersion(calculationRuleAddress: $calculationRuleAddress) {
                dataDependencies {
                  icon
                  name
                }
                releaseType
                version
                schema {
                  input {
                    name
                    columns {
                      nullable
                      name
                      typeName
                    }
                  }
                  output {
                    name
                    columns {
                      name
                      nullable
                      typeName
                    }
                  }
                }
                schemaDiff {
                  input {
                    changedTables {
                      name
                      changedColumns {
                        from {
                          name
                          nullable
                          typeName
                        }
                        to {
                          name
                          nullable
                          typeName
                        }
                      }
                      missingColumns {
                        name
                        nullable
                        typeName
                      }
                      newColumns {
                        name
                        nullable
                        typeName
                      }
                    }
                    missingTables {
                      name
                      columns {
                        name
                        nullable
                        typeName
                      }
                    }
                    newTables {
                      name
                      columns {
                        name
                        nullable
                        typeName
                      }
                    }
                  }
                  output {
                    changedTables {
                      name
                      changedColumns {
                        from {
                          name
                          nullable
                          typeName
                        }
                        to {
                          name
                          nullable
                          typeName
                        }
                      }
                      missingColumns {
                        name
                        typeName
                        nullable
                      }
                      newColumns {
                        name
                        nullable
                        typeName
                      }
                    }
                    missingTables {
                      name
                      columns {
                        name
                        nullable
                        typeName
                      }
                    }
                    newTables {
                      name
                      columns {
                        name
                        nullable
                        typeName
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export function useLazyQueryNewWebServicePreview() {
  return useLazyQuery<
    QueryNewWebServicePreview,
    QueryNewWebServicePreviewVariables
  >(queryNewWebServicePreview);
}

export function useLazyQueryUpgradeWebservicePreview() {
  return useLazyQuery<
    QueryUpgradeWebservicePreview,
    QueryUpgradeWebservicePreviewVariables
  >(queryUpgradeWebservicePreview);
}
